class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.fetchRecommendations();
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    }).observe(this);
  }
  fetchRecommendations() {
    const url = this.dataset.url;
    const productId = this.dataset.productId;
    const sectionId = this.dataset.sectionId;
    const limit = this.dataset.limit;
    const intent = this.dataset.intent;
    const fetchUrl = `${url}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`;
    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initSlider();
        }
      })
      .catch(e => {
        console.error('Failed to fetch product recommendations:', e);
      });
  }

  initSlider() {
    const track = this.querySelector('.related-products-track');
    const prevBtn = this.querySelector('.related-products-prev');
    const nextBtn = this.querySelector('.related-products-next');
    const slides = this.querySelectorAll('.related-products-slide');
    if (!track || slides.length === 0) return;

    let currentIndex = 0;
    const getSlidesPerView = () => window.innerWidth >= 768 ? 4 : 1;

    const updateSlider = () => {
      const slidesPerView = getSlidesPerView();
      const slideWidth = 100 / slidesPerView;
      track.style.transition = 'transform 0.3s ease-in-out';
      track.style.transform = `translateX(-${currentIndex * slideWidth}%)`;

      if (prevBtn && nextBtn) {
        const maxIndex = Math.max(0, slides.length - slidesPerView);
        prevBtn.classList.toggle('opacity-50', currentIndex <= 0);
        nextBtn.classList.toggle('opacity-50', currentIndex >= maxIndex);
      }
    };

    if(prevBtn && nextBtn) {
      prevBtn.replaceWith(prevBtn.cloneNode(true));
      nextBtn.replaceWith(nextBtn.cloneNode(true));
      const newPrevBtn = this.querySelector('.related-products-prev');
      const newNextBtn = this.querySelector('.related-products-next');

      newNextBtn.addEventListener('click', () => {
        const slidesPerView = getSlidesPerView();
        const maxIndex = slides.length - slidesPerView;
        if (currentIndex < maxIndex) {
          currentIndex++;
          updateSlider();
        }
      });
      newPrevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      });
    }

    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (event) => {
      if (getSlidesPerView() > 1) return; // Funziona solo su mobile
      touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (event) => {
      if (getSlidesPerView() > 1) return;
      touchEndX = event.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    const handleSwipe = () => {
      const swipeThreshold = 50;
      const slidesPerView = getSlidesPerView();
      const maxIndex = Math.max(0, slides.length - slidesPerView);

      if (touchStartX - touchEndX > swipeThreshold) {
        if (currentIndex < maxIndex) {
          currentIndex++;
        }
      } else if (touchEndX - touchStartX > swipeThreshold) {
        if (currentIndex > 0) {
          currentIndex--;
        }
      }
      updateSlider();
    };

    window.addEventListener('resize', () => {
      track.style.transition = 'none';
      updateSlider();
      setTimeout(() => {
        track.style.transition = 'transform 0.3s ease-in-out';
      }, 50);
    });

    updateSlider();
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
